import {
  POST_LOCAL_NOTIFICATION,
  REMOVE_LOCAL_NOTIFICATION
} from './constants/notifications'

const postLocalNotification =
  (message, duration = 3000) =>
  (dispatch) => {
    dispatch({
      type: POST_LOCAL_NOTIFICATION,
      message
    })
    window.setTimeout(() => {
      dispatch({
        type: REMOVE_LOCAL_NOTIFICATION
      })
    }, duration)
  }

export { postLocalNotification }
